export function getWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(globalThis).width() >= breakpoint;
}

export function headerSearchBarFix(searchPlaceholder) {
  const showMobileSearch = false;
  const mobileTrigger = getWindowSize(800);

  const $searchBox = $('.header .searchBox');
  $searchBox.find('.searchBoxSubmit .inputFieldSubmit').first().attr('tabindex', '-1');
  $searchBox.find('input').val('').attr('placeholder', searchPlaceholder);

  if (showMobileSearch) {
    $searchBox.addClass('mobile-enabled');

    if (!mobileTrigger) {
      $searchBox.attr('tabindex', '0');
    }
  }
}

export function updateContentMargin() {
  function applyMargin() {
    const headerHeight = $('header').outerHeight();

    const mq = globalThis.matchMedia('(max-width: 1100px)');
    const additionalValue = mq.matches ? 40 : 70;

    const $content = $('.content');
    const isHomepage = $('body').hasClass('homepage');
    const isRodeoLanding = $('body').hasClass('gnfa-rodeo-landing');
    const $subpageWidgets = $('.subpage-top-widgets');
    const subpageWidgetsVisible =
      isRodeoLanding && $subpageWidgets.length > 0 && $subpageWidgets.css('display') !== 'none';

    if (subpageWidgetsVisible) {
      $content.css('margin-top', '40px');
      $subpageWidgets.css('margin-top', `${headerHeight + additionalValue}px`);
    } else {
      $content.css(
        'margin-top',
        isHomepage ? `${headerHeight}px` : `${headerHeight + additionalValue}px`,
      );
    }
  }
  applyMargin();

  $(globalThis).on('resize scroll', applyMargin);
  new ResizeObserver(applyMargin).observe(document.querySelector('header'));
  new ResizeObserver(applyMargin).observe(document.querySelector('.subpage-top-widgets'));
}

export function modifyFeatureLineup() {
  const $lineups = $('.featureLineupContainer');
  if (!$lineups.length) return;

  $lineups.each((_, el) => {
    const $lineup = $(el);
    const containerWidth = $lineup.width();
    const $buttonContainer = $lineup.find('.featureLineup-buttons.subContainer');
    const $icons = $buttonContainer.find('.featureLineup-social');
    const $cta = $buttonContainer.find('.featureLineup-buynow');

    if (!$icons.children().length) {
      $icons.remove();
      $buttonContainer.addClass('no-social');
      return;
    }

    const totalWidth = $icons.outerWidth(true) + $cta.outerWidth(true);

    if (totalWidth > containerWidth) {
      $buttonContainer.addClass('column');
    }
  });
}

function safeUrl(url) {
  try {
    let u = new URL(url, globalThis.location.origin);
    return u.protocol === 'https:' || u.protocol === 'http:' ? u.href : '#';
  } catch {
    return '#';
  }
}

export function logosURL(themeData) {
  const activeSubtheme = (themeData || []).find((theme) => $('body').hasClass(theme.classBody));
  const url = activeSubtheme?.navItemUrl || '/';
  $('.header-logo').attr('href', safeUrl(url));
}

export const isPage = (className) => $('body').hasClass(className);

export function moveWidgetsBeforeContent(widgetContainer) {
  const $subpageWidgetsContainer = $('.afterContent').find(`#${widgetContainer}`);
  const $subpageWidgets = $subpageWidgetsContainer.children();
  const $content = $('.content');
  $content.before($subpageWidgets);
  $('.afterContent').empty();
}
